import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import color from "@constants/color";
import { useFocusEffect } from "@react-navigation/native";
import { getOutForDeliveryDb } from "@services/api";
import React, { useCallback, useState } from "react";
import { FlatList, View, StyleSheet, ActivityIndicator } from "react-native";
import OfdListTile from "./components/OfdListTile";
import OfdListFooter from "./components/OfdListFooter";

const OutForDelivery = ({ navigation, route }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, []),
  );

  const fetchData = async () => {
    try {
      setLoading(true);
      // eslint-disable-next-line no-shadow
      const { data } = await getOutForDeliveryDb();
      setData(data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const renderItem = ({ item }) => {
    return <OfdListTile item={item} />;
  };
  const ListFooterComponent = () => {
    return (
      <OfdListFooter
        title="Unassigned Customer"
        value={data?.unassigned_cx_count}
      />
    );
  };
  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle={data?.title || "Out For Delivery"}
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
      />
      {loading ? (
        <ActivityIndicator
          size="large"
          color={color.primary}
          style={styles.loading}
        />
      ) : (
        <FlatList
          data={data?.list || []}
          keyExtractor={(item) => item.db_id}
          renderItem={renderItem}
          style={{ marginTop: 8 }}
          ListFooterComponent={ListFooterComponent}
        />
      )}
    </View>
  );
};

export default OutForDelivery;

const styles = StyleSheet.create({
  loading: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});
